import { GrowthBook } from '@growthbook/growthbook';
import type { TrackingCallback } from '@growthbook/growthbook';
import type { GrowthBookVersionsModel, VersionsModel } from '@/common/models/versions.model.ts';

export default defineNuxtPlugin((nuxtApp) => {
  const route = useRoute();
  const { $db } = nuxtApp;
  const { f, ver, hp, l, p, mixmin } = route.query;
  const versions = ref<VersionsModel>({
    paymentForm: f as string,
    quiz: ver as string,
    homePage: hp as string,
    landing: l as string,
    upsale: p as string,
    trackOnlyAfterQuiz: mixmin === '1' ? '0' : '1',
  });
  let growthBook = null;

  async function initGrowthBook(
    trackingCallback: TrackingCallback,
    cmpId?: string,
    uuid?: string,
    distinctId?: string,
  ): Promise<GrowthBook | null> {
    try {
      growthBook = new GrowthBook({
        apiHost: 'https://cdn.growthbook.io',
        clientKey: 'sdk-ofNIO37SatebsZpf',
        enableDevMode: false, // runtimeConfig.public.ENVIRONMENT === 'development',
        trackingCallback,
        attributes: {
          cmpId,
          id: distinctId,
          user_id: uuid,
        },
      });

      await growthBook.init({ streaming: true });
      return growthBook;
    } catch (error: unknown) {
      console.error('GROWTHBOOK ERROR', error);
      return null;
    }
  }

  async function setVersions(growthBookVersions: GrowthBookVersionsModel): Promise<VersionsModel> {
    const { f, ver, hp, l, p, mixmin } = route.query;

    let minimalMixpanel = growthBookVersions.trackOnlyAfterQuiz;

    if (mixmin) {
      minimalMixpanel = mixmin === '1' ? '0' : '1';
    }
    const versionsObj = {
      paymentForm: f as string || growthBookVersions.paymentForm,
      quiz: ver as string || growthBookVersions.quiz,
      homePage: hp as string || growthBookVersions.homePage,
      landing: l as string || growthBookVersions.landing,
      upsale: p as string || growthBookVersions.upsale,
      trackOnlyAfterQuiz: minimalMixpanel,
    };

    versions.value = versionsObj;

    ($db as any).setItem('versions', versionsObj);

    return versions.value;
  }

  return {
    provide: {
      versions,
      growthBook,
      initGrowthBook,
      setVersions,
    },
  };
});
